import http from '@/plugins/http'

export default class UserProfile {
  static async show() {
    return await http.get('me')
  }
}
